export class NotFoundError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'NotFoundError';
    // Ensure proper prototype chain for `instanceof` checks
    Object.setPrototypeOf(this, NotFoundError.prototype);
  }
}
